export class ApiError extends Error {
  constructor({
    payload,
    status = 0,
    statusText = 'Unspecified error',
    headers = {}
  }) {
    super(`API Error (${status}): ${statusText}`);
    this.payload = payload;
    this.status = status;
    this.statusText = statusText;
    this.headers = headers;
  }
}